import TEMPLATE_URL from "emun.products/picker/product-picker.htm";
import controller from "emun.products/picker/product-picker.controller";
import open from "webmodals/open";

const NOOP = () => { };

export default ({
	size = "xl",
	backdrop = "static",
	templateUrl = TEMPLATE_URL,
	placement = undefined, // "right",
	title = "Select product(s)...",
	subTitle = "Add to product list",
	view = "table",
	single = false,
	viewSelections = false,
	dollarsAllowed = 0,
	okButtonText = "OK",
	closeButtonText = single ? "Close" : "Cancel",
	applyTagsButtonText = "Apply Tags",
	selected = {},
	criteria = { status: "Active" },
	onToggle = NOOP,
	onProductSelected = NOOP,
	onProductDeselected = NOOP
} = {}) =>
	open({
		size,
		backdrop,
		templateUrl,
		placement,
		controller,
		bindToController: true,
		controllerAs: "$ctrl",
		resolve: {
			options: () => ({
				title,
				subTitle,
				onProductSelected,
				onProductDeselected,
				onToggle,
				criteria,
				view,
				viewSelections,
				dollarsAllowed,
				okButtonText,
				closeButtonText,
				applyTagsButtonText,
				single,
				selected
			})
		}
	}).result;
